import { render, staticRenderFns } from "./AddAnnotationTypeDialog.vue?vue&type=template&id=5428cd43&scoped=true"
import script from "./AddAnnotationTypeDialog.vue?vue&type=script&lang=js"
export * from "./AddAnnotationTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./AddAnnotationTypeDialog.vue?vue&type=style&index=0&id=5428cd43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5428cd43",
  null
  
)

export default component.exports